// TechnicianAgreement.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function TechnicianAgreement() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 30, position: "left" }}>
      {/* X Button */}
      <button
        onClick={() => navigate("/technician-login")}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          fontSize: "20px",
          backgroundColor: "transparent",
          border: "none",
          color: "#333",
          cursor: "pointer"
        }}
      >
        ✖
      </button>

      <h2>Technician Agreement & Rules</h2>
      <ul>
        <li>Technicians must carry valid ID proof.</li>
        <li>Be punctual for assigned services.</li>
        <li>All payments will be made weekly to your bank account.</li>
        <li>Misbehavior with customers may lead to account suspension.</li>
        <li>Company reserves the right to review and remove technicians.</li>
      </ul>
    </div>
  );
}
